
    
    <div class="pt-3 flex flex-column gap-2" *ngIf="eventData!=null">
        <div class="input-field">
            <label for="caseLogTypeId">Categoría *</label>
            <p-dropdown [(ngModel)]="eventData.caseLogTypeId" [options]="caseLogTypes" optionLabel="name"
                        optionValue="id" appendTo="body" placeholder="Selecciona tipo evento" showClear styleClass="sm" [required]="true"
                        (onChange)="onCaseLogTypeChange()"></p-dropdown>

        </div>
        
        <!-- formulario propio del tipo de evento (CaseLogType / ContractCaseLogType) -->
        <app-dynamic-fields *ngIf="typeFields.length > 0" [fields]="typeFields" [data]="typeFieldsData"
                            [context]="dynamicContext"></app-dynamic-fields>

        <!-- formulario dinámico de integración (todas las integraciones salvo GENERALI, generado desde eventForm) -->
        <app-dynamic-fields *ngIf="showIntegrationFields" [fields]="integrationFields" [data]="integrationEventData"
                            [context]="dynamicContext" [extraTemplate]="integrationFilesTemplate"></app-dynamic-fields>

        <!-- tipos del formulario de integración ligados a adjuntos, que dependen de esta pantalla -->
        <ng-template #integrationFilesTemplate let-field>

            <!-- fichero (subida básica) -->
            <div class="input-field {{field.colClass || 'col-12'}}" *ngIf="field.type=='file-upload'">
                <label [for]="field.code">{{field.label}}<ng-container *ngIf="field.required"> *</ng-container></label>
                <div class="flex gap-2">
                    <button pButton label="" icon="pi pi-trash" class="p-button-danger" (click)="fileUpload.clear()" *ngIf="fileUpload.files.length>0"></button>
                    <p-fileUpload #fileUpload mode="basic" [accept]="field.accept || '*'" chooseIcon="pi pi-upload" (onSelect)="onSelectFile($event)" (onClear)="onClearFile($event)" [multiple]="false" chooseLabel="Seleccionar documento" />
                </div>
            </div>

            <!-- tarjeta de adjuntos -->
            <p-card class="p-card-content-pt-0 p-card-body-pt-0 col-12" *ngIf="field.type=='files-card'">
                <ng-template pTemplate="header">
                    <div class="flex justify-content-between align-items-center">
                        <div><b>{{field.label || 'Documentos adjuntos'}}</b></div>
                        <button pButton label="Añadir archivos" icon="pi pi-plus" (click)="showAddFiles()" size="small"></button>
                    </div>
                </ng-template>
                <div *ngFor="let file of integrationEventData?.files" class="mt-2 flex align-items-center gap-2">
                    <a (click)="removeFile(file)" class="p-button p-button-link text-red-500 cursor-pointer"><i class="pi pi-trash"></i></a>
                    {{file.name}}
                </div>
                <div *ngIf="integrationEventData?.files==null || integrationEventData?.files?.length == 0">No hay archivos adjuntos</div>
            </p-card>

        </ng-template>

        <!-- integración generali -->
        <div *ngIf="integration?.code=='GENERALI' && integrationConfiguration!=null && isCompanyCaseLogType(eventData?.caseLogTypeId)" class="flex flex-column gap-2">
            <div class="input-field">
                <label for="caseLogTypeId">Tipo de notificación</label>
                <p-dropdown [(ngModel)]="integrationEventData.communicationId" [options]="integrationConfiguration?.communicationTypes" optionLabel="label"
                            optionValue="value" appendTo="body" placeholder="Selecciona tipo" showClear styleClass="sm" (onChange)="onGeneraliCommunicationTypeChange()"></p-dropdown>
            </div>
            <div class="input-field" *ngIf="integrationEventData.communicationId=='NEW_DIALOG' || integrationEventData.communicationId=='RESPONSE_DIALOG'">
                <label for="caseLogTypeId">Asunto *</label>
                <p-dropdown [(ngModel)]="integrationEventData.subjectId" [options]="generali.newDialogOptions?.subjectOptions" optionLabel="text" optionValue="value" appendTo="body" placeholder="Selecciona asunto" showClear styleClass="sm" [required]="true"></p-dropdown>
            </div>
            <div class="input-field" *ngIf="integrationEventData.communicationId=='RESPONSE_DIALOG'">
                <label for="caseLogTypeId">Dialogo *</label>
                <p-dropdown [(ngModel)]="integrationEventData.dialogId" [options]="generali.dialogs" optionLabel="subject" optionValue="dialogId" appendTo="body" placeholder="Selecciona asunto" showClear styleClass="sm" [required]="true">
                    <ng-template let-dialog pTemplate="item">
                        <div class="flex flex-column" style="max-width: 300px;">
                            <span>{{dialog.subject}}</span>
                            <small>{{dialog.lastMessageDate | date:'dd/MM/yyyy HH:mm:ss'}}</small>
                        </div>
                    </ng-template>
                </p-dropdown>
            </div>
            <div class="input-field" *ngIf="integrationEventData.communicationId=='NEW_DIALOG' || integrationEventData.communicationId=='RESPONSE_DIALOG'">
                <label for="destinataryId">Destinatario *</label>
                <p-dropdown [(ngModel)]="integrationEventData.destinataryId" [options]="generali.newDialogOptions?.destinataryOptions" optionLabel="text" optionValue="value" appendTo="body" placeholder="Selecciona asunto" showClear styleClass="sm" [required]="true"></p-dropdown>
            </div>
            <div class="input-field" *ngIf="integrationEventData.communicationId=='NEW_DIALOG' || integrationEventData.communicationId=='RESPONSE_DIALOG'">
                <label for="answerRequired">Requiere respuesta</label>
                <p-checkbox [(ngModel)]="integrationEventData.answerRequired" [binary]="true"></p-checkbox>
            </div>
            <div class="input-field" *ngIf="integrationEventData.communicationId=='NEW_SITUATION'">
                <label for="communicationId">Situación *</label>
                <p-dropdown [(ngModel)]="integrationEventData.situationId" [options]="generali.situationOptions?.situationOptions" optionLabel="text" optionValue="value" appendTo="body" placeholder="Selecciona asunto" showClear styleClass="sm" [required]="true"></p-dropdown>
            </div>
            <div class="input-field" *ngIf="integrationEventData.communicationId=='NEW_SITUATION'">
                <label for="destinataryId">Destinatario *</label>
                <p-dropdown [(ngModel)]="integrationEventData.destinataryId" [options]="generali.situationOptions?.destinataryList" optionLabel="text" optionValue="value" appendTo="body" placeholder="Selecciona asunto" showClear styleClass="sm" [required]="true"></p-dropdown>
            </div>
            <div class="input-field" *ngIf="integrationEventData.communicationId=='NEW_SITUATION' && getGeneraliSituation(integrationEventData.situationId)?.guildRequired">
                <label for="guildId">Especialidad *</label>
                <p-dropdown [(ngModel)]="integrationEventData.guildId" [options]="generali.situationOptions?.guildList" optionLabel="text" optionValue="value" appendTo="body" placeholder="Selecciona asunto" showClear styleClass="sm" [required]="true"></p-dropdown>
            </div>
            <div class="input-field" *ngIf="integrationEventData.communicationId=='NEW_SITUATION' && getGeneraliSituation(integrationEventData.situationId)?.previsionDateRequired">
                <label for="previsionDate">Fecha prevista *</label>
                <p-calendar [firstDayOfWeek]="1" [(ngModel)]="integrationEventData.previsionDate" [showIcon]="true" [showTime]="true" [hourFormat]="'24'" dateFormat="dd/mm/yy" appendTo="body" [required]="true" ></p-calendar>
            </div>
            <div class="input-field" *ngIf="integrationEventData.communicationId=='NEW_SITUATION' && getGeneraliSituation(integrationEventData.situationId)?.futureActionRequired">
                <label for="futureActionDate">Fecha de acción futura *</label>
                <p-calendar [firstDayOfWeek]="1" [(ngModel)]="integrationEventData.futureActionDate" [showIcon]="true" [showTime]="true" [hourFormat]="'24'" dateFormat="dd/mm/yy" appendTo="body" [required]="true"></p-calendar>
            </div>
            <div class="input-field" *ngIf="integrationEventData.communicationId=='NEW_SITUATION' && getGeneraliSituation(integrationEventData.situationId)?.futureActionRequired">
                <label for="futureActionDescription">Descripción de acción futura</label>
                <input pInputText [(ngModel)]="integrationEventData.futureActionDescription"/>
            </div>
            <div class="input-field" *ngIf="integrationEventData.communicationId=='NEW_SITUATION' && getGeneraliSituation(integrationEventData.situationId)?.futureActionRequired">
                <label for="futureActionPresencial">Presencial</label>
                <p-checkbox [(ngModel)]="integrationEventData.futureActionPresencial" [binary]="true"></p-checkbox>
            </div>
            <div class="input-field" *ngIf="integrationEventData.communicationId=='TECHNICAL_CALL_REQUEST'">
                <label for="phone">Teléfono</label>
                <input pInputText [(ngModel)]="integrationEventData.phone" />
            </div>

            <p-card class="p-card-content-pt-0 p-card-body-pt-0">
                <ng-template pTemplate="header">
                    <div class="flex justify-content-between align-items-center">
                        <div><b>Documentos adjuntos</b></div>
                        <button pButton label="Añadir archivos" icon="pi pi-plus" (click)="showAddFiles()"  size="small"></button>
                    </div>
                </ng-template>
                <div *ngFor="let file of integrationEventData?.files" class="mt-2 flex align-items-center gap-2">
                    <a (click)="removeFile(file)" class="p-button p-button-link text-red-500 cursor-pointer"><i class="pi pi-trash"></i></a>
                    {{file.name}}
                </div>
                <div *ngIf="integrationEventData?.files==null || integrationEventData?.files?.length == 0">No hay archivos adjuntos</div>
            </p-card>
        </div>

        <div class="input-field">
            <label for="message">Mensaje<ng-container *ngIf="isMessageRequired"> *</ng-container></label>
            <textarea pInputTextarea rows="5" [(ngModel)]="eventData.message" [attr.maxlength]="messageMaxLength"></textarea>
            <small class="p-error" *ngIf="messageMaxLength != null && (eventData.message?.length ?? 0) >= messageMaxLength">La longitud máxima del mensaje a Generali es de {{messageMaxLength}} caracteres.</small>
        </div>
    </div>
    

    <div class="pt-3 flex justify-content-end gap-2">
        <button pButton (click)="templateSearch=''; op.toggle($event)" class="p-button-secondary" pTooltip="Seleccionar plantilla" icon="pi pi-sparkles"></button>
        <div class="flex-grow-1"></div>
        <button pButton label="Cancelar" icon="pi pi-times" class="p-button-secondary" (click)="cancel()"></button>
        <button pButton label="Guardar" icon="pi pi-save" (click)="save()"></button>
    </div>


    <p-dialog header="Seleccionar archivos" appendTo="body" [modal]="true" [(visible)]="selectFilesVisible" [style]="{ width: '1024px' }">

        <div class="grid">
            <p-card header="Sin servicio" *ngIf="caseFilesWithoutService.length > 0" styleClass=" p-card-content-no-padding"  [style]="{ background: 'white' }">
                <div class="grid">
                    <div *ngFor="let file of caseFilesWithoutService; let  i = index">
                        <div style="border: 1px solid #e9e9e9; padding: 10px; border-radius: 10px;">
                            <div style="text-align: center;">
                                    <img [d-img-lazy]="imagesUrl + file.fileId + '/thumbnail'" alt="{{file.file.fileName}}" width="150px" style="max-width: 150px; max-height: 150px;"/>
                                </div>
                            <div class="flex justify-content-between align-items-center mt-1">
                                <span>{{file.index}}.&nbsp;{{file.file.caseFileCategory?.name}}</span>
                            </div>
                            <div>
                                <p-dropdown *ngIf="integration?.code == 'GENERALI'" [(ngModel)]="file.selected" (onChange)="onFileTypeChange($event, file)" [options]="generali.situationOptions?.documentTypes" optionLabel="text" optionValue="value" appendTo="body" placeholder="Selecciona tipo" showClear styleClass="sm"></p-dropdown>
                                <p-dropdown *ngIf="isDynamicIntegration" [(ngModel)]="file.selected" (onChange)="onFileTypeChange($event, file)" [options]="integrationConfiguration?.eventForm?.fileTypes" optionLabel="text" optionValue="value" appendTo="body" placeholder="Selecciona tipo" showClear styleClass="sm"></p-dropdown>
                            </div>
                        </div>
                    </div>
                </div>
            </p-card>
            <div *ngFor="let service of caseFilesServices" class="w-full" >
                <p-card styleClass="mt-2 p-card-content-no-padding" [style]="{ background: 'white' }" >
                    <ng-template pTemplate="header">
                        <div class="p-card-title flex gap-2">
                            <div>{{service.name}} </div>
                            <div class="flex-grow-1"></div>
                            <p-button label="Seleccionar todos con tipo" icon="pi pi-angle-down" class="ui-button-info"
                                (click)="serviceId = service.id; menuAllImages.toggle($event)"></p-button>
                            <p-menu #menuAllImages [model]="items" [popup]="true" appendTo="body"></p-menu>
                            <!-- <p-splitButton label="Seleccionar todos con tipo:" class="ui-button-info"
                                (onDropdownClick)="serviceId = service.id" [model]="items"  appendTo="body"></p-splitButton>-->
                        </div>
                    </ng-template>
                    <div class="grid">
                        <div *ngFor="let file of filesByService(service.id);let  i = index">
                            <div style="border: 1px solid #e9e9e9; padding: 10px; border-radius: 10px;">
                                <div style="text-align: center;">
                                    <img [d-img-lazy]="imagesUrl + file.fileId + '/thumbnail'" alt="{{file.file.fileName}}" width="150px" style="max-width: 150px; max-height: 150px;"/>
                                </div>
                                <div class="flex justify-content-between align-items-center mt-1">
                                    <span>{{file.index}}.&nbsp;{{file.caseFileCategory?.name}}</span>
                                </div>
                                <div>
                                    <p-dropdown *ngIf="integration?.code == 'GENERALI'" [(ngModel)]="file.selected" (onChange)="onFileTypeChange($event, file)" [options]="generali.situationOptions?.documentTypes" optionLabel="text" optionValue="value" appendTo="body" placeholder="Selecciona tipo" showClear styleClass="sm"></p-dropdown>
                                    <p-dropdown *ngIf="isDynamicIntegration" [ngModel]="file.selected" (onChange)="onFileTypeChange($event, file)" [options]="integrationConfiguration?.eventForm?.fileTypes" optionLabel="text" optionValue="value" appendTo="body" placeholder="Selecciona tipo" showClear styleClass="sm"></p-dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                </p-card>
            </div>
        </div>
        <div class="pt-3 flex justify-content-end gap-2">
            <button pButton label="Cancelar" icon="pi pi-times" class="p-button-secondary" (click)="hideAddFiles()"></button>
            <button pButton label="Añadir seleccionados" icon="pi pi-save" (click)="addSelectedFiles()"></button>
        </div>
    </p-dialog>


    <p-overlayPanel #op [style]="{ width: '350px' }">
        <ng-template pTemplate="content">
            <div class="input-field" style="position: relative; margin-bottom: 10px;">
                <input type="text" pInputText placeholder="Texto a buscar..." [(ngModel)]="templateSearch" />
                <i class="pi pi-search" style="position: absolute; right: 10px; top: 10px;"></i>
            </div>
            <div *ngFor="let template of getFilteredTemplatesCaseLogs(); index as i" class="template">
                <div class="flex align-items-center gap-2">
                    <div class="flex flex-column flex-grow-1">
                        <span>{{template.name}}</span>
                        <small style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden; width: 250px;">{{template.content}}</small>
                    </div>
                    <button pButton icon="pi pi-chevron-right" (click)="eventData.message = template.content??''; op.hide()" size="small"></button>
                </div>
            </div>
            <div *ngIf="getFilteredTemplatesCaseLogs().length === 0">No se encontraron plantillas de comunicación</div>
        </ng-template>
    </p-overlayPanel>